import { Icon, Text } from '@cencosud-cencommerce/paris-uikit';
import classNames from 'classnames';

import { useGetCustomerData } from '@/Application/Hooks/GetCustomerData';

export const IntangiblePanel = () => {
  return (
    <div
      className={classNames(
        'co-flex co-flex-col co-p-3 tablet_w:co-py-6 tablet_w:co-px-4',
        'co-gap-3 tablet_w:co-gap-4'
      )}
    >
      <div
        className={classNames(
          'co-flex co-gap-4 co-bg-neutral-100 co-rounded-lg co-p-2',
          'tablet_w:co-px-4 tablet_w:co-py-2'
        )}
      >
        <Icon
          name="il-email"
          className="co-h-8 co-w-8 tablet_w:co-h-11 tablet_w:co-w-11"
        />
        <div className="co-flex co-flex-col">
          <Text variant="body2" color="primary-500" weight={600}>
            Entrega por correo
          </Text>
          <Text variant="caption" className="co-max-w-[272px]">
            Te enviaremos un correo con tu producto o la información para
            agendar el servicio.
          </Text>
        </div>
      </div>
      <EmailLabel />
    </div>
  );
};

const EmailLabel = () => {
  const { email } = useGetCustomerData();

  return (
    <div
      className={classNames(
        'co-flex co-flex-col co-gap-1',
        'co-px-3 tablet_w:co-px-4'
      )}
    >
      <Text variant="caption" weight={600}>
        Mi correo electrónico:
      </Text>
      <Text variant="caption">{email}</Text>
    </div>
  );
};
